import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=d8897734"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"
import style0 from "./Stores.vue?vue&type=style&index=0&id=d8897734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports